import React from "react";
import { textPrimary } from "./colors";

const Text = props => {
  return (
    <span
      className={props.className}
      style={{
        display: props.block ? "block" : "unset",
        textTransform: props.textTransform || "unset",
        color: props.color ? props.color : textPrimary,
        fontSize: props.fontSize ? props.fontSize : "1rem",
        fontWeight: props.fontWeight
          ? props.fontWeight
          : props.bold
          ? 700
          : 400,
        lineHeight: props.lineHeight ? props.lineHeight : "1.25rem",
        letterSpacing: props.letterSpacing || "0.26px",
        textAlign: props.textAlign || "unset",
        ...props.style,
        verticalAlign: props.verticalAlign || "unset",
      }}
    >
      {props.children}
    </span>
  );
};

export default Text;
